module.exports = __webpack_public_path__ + "static/media/3.56343299.jpg";